import React from "react";
import axios from "axios";
import { useLocation } from "react-router-dom";
import { ListGroup, Button, Container } from "react-bootstrap";
import "./Home.scss"; // Import the SCSS file
import PSGLOGO from "../Assets/Images/PSG HOSPITALS LOGO.jpg";
const baseurl = `https://hsissmart.psghospitals.com/ps2/api/feedback`;
const Home = () => {
  const location = useLocation();
  const { transactionData } = location.state || [];
  const maskName = (name) => {
    if (!name) return ""; // If name is undefined or empty, return an empty string
    return name.replace(/./g, "*"); // Replace each character with '*'
  };
  const handlePrintOgShortnotes = async (transactionId) => {
    const url = `${baseurl}/recivePdf`;

    try {
      const result = await axios.post(
        url,
        { transNo: transactionId }, // Add transactionId to the POST body
        { responseType: "blob" }
      );

      const blob = new Blob([result.data], { type: "application/pdf" });
      const blobUrl = window.URL.createObjectURL(blob);

      window.open(blobUrl, "_blank");

      setTimeout(() => window.URL.revokeObjectURL(blobUrl), 100);
    } catch (error) {
      console.error("Error fetching the PDF:", error);
    }
  };

  return (
    <>
      {" "}
      <div className="watermark"></div>
      <Container className="home-container">
        <div className="text-center mb-4">
          <img
            src={PSGLOGO} // Replace with your logo path
            alt="Logo"
            style={{ width: "100px", height: "auto" }} // Adjust the size as needed
          />
        </div>
        {/* Watermark */}
        {/* <div className="watermark">PSGH</div> */}
        <h2 className="text-center my-4">Transaction List</h2>
        <ListGroup>
          {transactionData.length > 0 ? (
            transactionData.map((transaction, index) => (
              <ListGroup.Item key={index} className="transaction-item">
                <div className="transaction-details">
                  <div className="transaction-detail">
                    <strong>Transaction ID:</strong>
                    <p>{transaction.TRAN_ID}</p>
                  </div>
                  <div className="transaction-detail">
                    <strong>Date:</strong>
                    <p>{new Date(transaction.TRAN_DATE).toLocaleString()}</p>
                  </div>
                  <div className="transaction-detail">
                    <strong>Department:</strong>
                    <p>{transaction.DEPT_LNAME}</p>
                  </div>
                  <div className="transaction-detail">
                    <strong>Name:</strong>
                    <p>{maskName(transaction.NAME)}</p>
                  </div>
                  {/* <div className="transaction-detail">
                    <strong>Age:</strong>
                    <p>{transaction.AGE}</p>
                  </div> */}
                </div>
                <Button
                  onClick={() => handlePrintOgShortnotes(transaction.TRAN_ID)}
                  className="mt-3"
                  variant="primary"
                >
                  View prescription
                </Button>
              </ListGroup.Item>
            ))
          ) : (
            <p className="text-center">No transaction data available.</p>
          )}
        </ListGroup>
      </Container>
    </>
  );
};

export default Home;
